import { formatInTimeZone } from 'date-fns-tz';
import de from 'date-fns/locale/de';
import styled from '@emotion/styled';

import { icons } from '@toolbox/components/Timeslots/Icon/icons';
import { ConfirmationRow } from './ConfirmationRow';
import { APPOINTMENT_TYPE, SALES_APPOINTMENT_TYPE } from '@widget/api/types';

import type { WidgetFormData } from '@widget/types/WidgetFormData';

const CalendarIcon = icons['calendar-full'];
const ClockIcon = icons['clock'];
const CallIcon = icons['call'];
const LocationIcon = icons['location'];
const AppointmentTypeCallIcon = icons['AppointmentTypeCall'];
const AppointmentTypeOnsitelIcon = icons['AppointmentTypeOnsite'];

export const Container = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }
`;

interface ConfirmationDataProps {
  isoString?: string;
  timezone: string;
  phone?: string;
  address?: string;
  appointmentType?: WidgetFormData['bookingType'];
}
export const ConfirmationData = ({
  isoString,
  timezone,
  phone,
  address,
  appointmentType,
}: ConfirmationDataProps) => {
  const bookDate = isoString
    ? formatInTimeZone(isoString, timezone, 'EEEE, dd MMMM', { locale: de })
    : '';
  const bookTime = isoString
    ? formatInTimeZone(isoString, timezone, 'HH:mm (zzz)', {
        locale: de,
      })
    : '';
  return (
    <Container>
      {!!bookDate && (
        <ConfirmationRow icon={<CalendarIcon />} label="Datum" value={bookDate} order={1} />
      )}
      {!!bookTime && (
        <ConfirmationRow icon={<ClockIcon />} label="Zeit" value={`${bookTime} Uhr`} order={3} />
      )}
      {!!phone && <ConfirmationRow icon={<CallIcon />} label="Kontakt" value={phone} order={2} />}
      {!!address && (
        <ConfirmationRow icon={<LocationIcon />} label="Adresse" value={address} order={4} />
      )}
      {[APPOINTMENT_TYPE.CALL, SALES_APPOINTMENT_TYPE].some((type) => appointmentType === type) && (
        <ConfirmationRow
          icon={<AppointmentTypeCallIcon />}
          label="Termin-Art"
          value={'Telefon'}
          order={5}
        />
      )}
      {appointmentType === APPOINTMENT_TYPE.ON_SITE && (
        <ConfirmationRow
          icon={<AppointmentTypeOnsitelIcon />}
          label="Termin-Art"
          value={'Vor Ort'}
          order={5}
        />
      )}
    </Container>
  );
};
